import creativeCollProfile from '../assets/images/Discover/creativeCollProfile.png';

import postImage02 from '../assets/images/HomePage/postImage02.png';
import postImage03 from '../assets/images/HomePage/postImage03.png';
import postImage04 from '../assets/images/HomePage/postImage04.png';
import postImage05 from '../assets/images/HomePage/postImage05.png';
import postImage06 from '../assets/images/HomePage/postImage06.png';


import bid1 from '../assets/images/explore/bid1.png';
import bid2 from '../assets/images/explore/bid2.png';
import bid3 from '../assets/images/explore/bid3.png';

export interface myWatchListDataType {
    id: number,
    logo: string,
    name: string,
    floorPrice: number,
    volume: number,
    hours24: string,
    day: string,
    ownersNum: number,
    items: number,
}



export const myWatchListData: myWatchListDataType[] = [

    {
        id: 1,
        logo: bid1,
        name: 'The Northman',
        floorPrice: 7.29,
        volume: 11436.34,
        hours24: '--',
        day: '--',
        ownersNum: 834,
        items: 2000,
    },
    {
        id: 2,
        logo: bid2,
        name: 'Hamlet Contemplates',
        floorPrice: 7.29,
        volume: 11436.34,
        hours24: '--',
        day: '--',
        ownersNum: 834,
        items: 2000,
    },
    {
        id: 3,
        logo: bid3,
        name: 'Kitty world',
        floorPrice: 7.29,
        volume: 11436.34,
        hours24: '--',
        day: '--',
        ownersNum: 834,
        items: 2000,
    },


]








export interface myCollectionsType {
    id: number,
    thumbs: {
        id: number,
        source: string,
        isVideo?: boolean,
        videoSrc?: string,
    }[],
    profilePhoto: string,
    profileName: string,
    isVerified: boolean,
    isMyLoved?: boolean,
    owner: string,
    loves: number,
}

export const myCollections: myCollectionsType[] = [
    {
        id: 1,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: postImage02 },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage03 },
            { id: 7, source: 'https://cdn.pixabay.com/photo/2022/05/21/16/00/butterfly-7211806_960_720.jpg' },
            { id: 8, source: 'https://cdn.pixabay.com/photo/2022/05/16/19/14/road-7201023_960_720.jpg' },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        isMyLoved: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
    {
        id: 2,
        thumbs: [
            { id: 1, source: postImage03 },
            // { source: postImage05 },
            // { source: 'https://cdn.pixabay.com/photo/2016/10/25/12/28/iceland-1768744_960_720.jpg' },
            // { source: postImage04 },
            // { source: postImage06 },
            // { source: postImage03 },
            // { source: postImage05 },
            // { source: postImage02 },
            // { source: postImage04 },
            // { source: "https://cdn.pixabay.com/photo/2018/07/10/10/29/girl-3528292_960_720.jpg" },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
    {
        id: 3,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: postImage02 },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage06 },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
    {
        id: 4,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: postImage02 },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage06 },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
]